<script lang="ts">
import { defineComponent as DO_defineComponent } from 'vue';
export default /*#__PURE__*/ DO_defineComponent({
	name: 'ToCollapseItem'
});
</script>
<template>
	<div :class="['to-collapse-item', disabled ? 'is-dis' : '', isActive ? 'is-on' : '']">
		<slot name="header" :item="{ isOn: isActive, title, isDisabled: disabled }">
			<to-header link :class="['to-collapse-item-header']" @click="itemClick">
				<template #title>
					<slot name="title">{{ title }}</slot>
				</template>
				<slot name="fn"></slot>
				<to-icon value="next" class="to-collapse-item-arrow"></to-icon>
			</to-header>
		</slot>
		<div class="to-collapse-item-content" :style="{ height: isActive ? calcHeight : '0px' }">
			<div ref="containerRef" class="to-collapse-item-wrapper">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { computed, inject, nextTick, ref, watch } from 'vue'
import { IStore } from './collapse.vue'
import { getEm } from '@touchvue/utils'


export interface Props {
	value: string
	title?: string
	disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
	value: '',
	title: '',
	disabled: false
})
const emit = defineEmits(['title-click', 'change'])
const isActive = ref(false)
const Store = inject<IStore>('Store')

Store.addChild(props.value)

watch(
	() => Store.activeValue.value,
	value => {
		if (value.includes(props.value)) {
			isActive.value = true
		} else {
			isActive.value = false
		}
	},
	{ deep: true }
)

const containerRef = ref(null)
const calcHeight = computed(() => {
	let em = getEm()
	let h = containerRef.value.clientHeight / em + 'em'
	return h
})

function itemClick() {
	if (!props.disabled) {
		Store.setActiveValues(props.value)
		nextTick(() => {
			emit('change', isActive.value)
		})
	}
}
</script>
